import axios from "axios";

import { functionBaseUrl } from "./firebase";

export const checkUserAcc = async (email) => {
  try {
    const res = await axios(functionBaseUrl + "/api/userInAuth", {
      method: "POST",
      data: { email: email.toLowerCase().replace(/ /g, "") },
    });

    return res.status !== 200;
  } catch (err) {
    console.log(err);

    return false;
  }
};

export const validatePassword = (password) => {
  const verify = /^(?=.*\d)(?=.*[.!@#$%^&*])(?=.*[a-z]).{8,}$/;
  return verify.test(password);
};

export const validateEmail = (email) => {
  const verify = /\S+@\S+\.\S+/;
  return verify.test(email);
};

export const dobFormat = (dob) => {
  let [year, month, day] = dob.split("-");
  return month + "/" + day + "/" + year;
};
